import ComponentModule from "@eisinc/Overrides/Components/CartTotalDisplay";

export * from "@eisinc/Overrides/Components/CartTotalDisplay";

export default ComponentModule;
